module.exports = __webpack_public_path__ + "static/media/model-side-pic.c08ee34a.png";